import { 
  REQUEST_SLIDERS,
  RECEIVE_SLIDERS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  sliders: {},
  loading: true,
};

function sliderReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_SLIDERS: {
      return { ...state, loading: true };
    }
    case RECEIVE_SLIDERS: {
      return { 
        sliders: action.response,
        loading: false,
      };
    }
    default:
      return state;
  }
}

export default sliderReducer;